export const en = {
  // Navigation
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    contact: 'Contact',
    implants: 'Implants',
    veneers: 'Veneers',
    composite: 'Composite Build-up',
    technology: 'Technologies',
    book: 'Booking',
    emergency: 'Emergency',
    privacyPolicy: 'Privacy Policy',
    legalNotice: 'Legal Notice',
    admin: 'Admin'
  },

  // Header
  header: {
    logoText: "SeaDent Mallorca",
    phone: "603 31 96 48",
    whatsapp: "WhatsApp",
    languageToggle: "DE",
    reviews: {
      rating: "5.0",
      count: "470+ reviews",
      google: "Google Reviews"
    }
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    edit: 'Edit',
    delete: 'Delete',
    clear: 'Clear',
    refresh: 'Refresh',
    search: 'Search',
    filter: 'Filter',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    time: 'Time',
    email: 'Email',
    phone: 'Phone',
    notes: 'Notes',
    created: 'Created',
    updated: 'Updated',
    name: 'Name',
    description: 'Description',
    duration: 'Duration',
    color: 'Color',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    minutes: 'minutes',
    bookNow: 'Book Now'
  },

  // Cookie Consent
  cookieConsent: {
    title: "Cookie Settings",
    description: "We use cookies to improve your experience on our website. By using our website, you agree to our cookie policy.",
    acceptAll: "Accept All",
    acceptNecessary: "Only Necessary",
    settings: "Settings",
    save: "Save Settings",
    close: "Close",
    privacyPolicy: "Privacy Policy",
    categories: {
      necessary: {
        title: "Necessary",
        description: "These cookies are required for the website to function and cannot be disabled."
      },
      preferences: {
        title: "Preferences",
        description: "These cookies allow the website to remember choices you have made."
      },
      statistics: {
        title: "Statistics",
        description: "These cookies help us understand how visitors interact with the website."
      },
      marketing: {
        title: "Marketing",
        description: "These cookies are used to provide visitors with relevant ads and marketing campaigns."
      }
    }
  },

  // Admin
  admin: {
    title: 'Admin Dashboard',
    login: 'Login',
    logout: 'Logout',
    dashboard: 'Dashboard',
    username: 'Username',
    password: 'Password',
    loginButton: 'Sign In',
    loginError: 'Invalid credentials',
    loginRequired: 'Please log in to access the admin panel',
    welcome: 'Welcome to the Admin Dashboard',
    overview: 'Overview',
    quickActions: 'Quick Actions',
    recentActivity: 'Recent Activity',
    systemStatus: 'System Status',
    googleCalendarStatus: 'Google Calendar',
    databaseStatus: 'Database',
    connected: 'Connected',
    disconnected: 'Disconnected',
    healthy: 'Healthy',
    error: 'Error'
  },

  // Calendar
  calendar: {
    title: 'Appointment Calendar',
    next: 'Next',
    previous: 'Previous',
    today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    noEvents: 'No appointments in this time range',
    filterBy: 'Filter by',
    allProviders: 'All Providers',
    allProcedures: 'All Procedures',
    allOperatories: 'All Operatories',
    refresh: 'Refresh Calendar',
    googleCalendarSync: 'Syncing...'
  },

  // Appointments
  appointments: {
    title: 'Appointments',
    create: 'Create Appointment',
    edit: 'Edit Appointment',
    update: 'Update Appointment',
    view: 'View Appointment',
    delete: 'Delete Appointment',
    cancel: 'Cancel Appointment',
    confirm: 'Confirm',
    completed: 'Mark Complete',
    noShow: 'No Show',
    patient: 'Patient',
    provider: 'Provider',
    procedure: 'Procedure',
    operatory: 'Operatory',
    date: 'Date',
    time: 'Time',
    startTime: 'Start Time',
    endTime: 'End Time',
    status: 'Status',
    notes: 'Notes',
    language: 'Language',
    total: 'Total Appointments',
    today: 'Today',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    upcoming: 'Upcoming',
    recent: 'Recent',
    search: 'Search appointments...',
    filters: 'Filters',
    exportToExcel: 'Export to Excel',
    importFromExcel: 'Import from Excel',
    bulkActions: 'Bulk Actions',
    selectAll: 'Select All',
    selectedCount: 'Selected: {count}',
    conflictDetected: 'Schedule conflict detected',
    googleCalendarEvent: 'Google Calendar Event',
    syncWithGoogleCalendar: 'Sync with Google Calendar',
    createGoogleCalendarEvent: 'Create Google Calendar Event',
    updateGoogleCalendarEvent: 'Update Google Calendar Event',
    deleteGoogleCalendarEvent: 'Delete Google Calendar Event'
  },

  // Providers
  providers: {
    title: 'Providers',
    add: 'Add Provider',
    edit: 'Edit Provider',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    specialization: 'Specialization',
    schedule: 'Schedule',
    active: 'Active',
    inactive: 'Inactive',
    workingHours: 'Working Hours',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    startTime: 'Start Time',
    endTime: 'End Time',
    dayOff: 'Day Off',
    saveSchedule: 'Save Schedule',
    scheduleUpdated: 'Schedule updated successfully'
  },

  // Procedures
  procedures: {
    title: 'Procedures',
    add: 'Add Procedure',
    edit: 'Edit Procedure',
    name: 'Name',
    description: 'Description',
    duration: 'Duration (minutes)',
    price: 'Price',
    category: 'Category',
    color: 'Color',
    active: 'Active',
    inactive: 'Inactive',
    categories: {
      consultation: 'Consultation',
      cleaning: 'Cleaning',
      filling: 'Filling',
      crown: 'Crown',
      implant: 'Implant',
      veneer: 'Veneer',
      extraction: 'Extraction',
      root_canal: 'Root Canal',
      orthodontics: 'Orthodontics',
      surgery: 'Surgery',
      other: 'Other'
    }
  },

  // Operatories
  operatories: {
    title: 'Operatories',
    add: 'Add Operatory',
    edit: 'Edit Operatory',
    name: 'Name',
    description: 'Description',
    equipment: 'Equipment',
    capacity: 'Capacity',
    active: 'Active',
    inactive: 'Inactive',
    location: 'Location',
    floor: 'Floor',
    room: 'Room',
    specialEquipment: 'Special Equipment'
  },

  // Status
  status: {
    scheduled: 'Scheduled',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled',
    no_show: 'No Show',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    active: 'Active',
    inactive: 'Inactive'
  },

  // Messages
  messages: {
    appointmentCreated: 'Appointment created successfully',
    appointmentUpdated: 'Appointment updated successfully',
    appointmentDeleted: 'Appointment deleted successfully',
    appointmentCancelled: 'Appointment cancelled successfully',
    providerCreated: 'Provider created successfully',
    providerUpdated: 'Provider updated successfully',
    providerDeleted: 'Provider deleted successfully',
    procedureCreated: 'Procedure created successfully',
    procedureUpdated: 'Procedure updated successfully',
    procedureDeleted: 'Procedure deleted successfully',
    operatoryCreated: 'Operatory created successfully',
    operatoryUpdated: 'Operatory updated successfully',
    operatoryDeleted: 'Operatory deleted successfully',
    saveSuccess: 'Changes saved successfully',
    deleteSuccess: 'Item deleted successfully',
    confirmDelete: 'Are you sure you want to delete this item?',
    confirmCancel: 'Are you sure you want to cancel this appointment?',
    conflictDetected: 'A scheduling conflict has been detected',
    googleCalendarSynced: 'Google Calendar synchronized successfully',
    googleCalendarError: 'Error syncing with Google Calendar',
    googleCalendarSync: 'Syncing with Google Calendar...',
    exportSuccess: 'Data exported successfully',
    importSuccess: 'Data imported successfully',
    noDataToExport: 'No data to export',
    invalidFileFormat: 'Invalid file format',
    networkError: 'Network error. Please try again.',
    sessionExpired: 'Session expired. Please log in again.',
    accessDenied: 'Access denied',
    formValidationError: 'Please correct the errors in the form',
    requiredField: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    invalidDate: 'Please enter a valid date',
    invalidTime: 'Please enter a valid time',
    startTimeAfterEndTime: 'Start time must be before end time',
    duplicateEntry: 'This entry already exists',
    noResults: 'No results found',
    loadingData: 'Loading data...',
    noDataAvailable: 'No data available'
  },

  // Reports
  reports: {
    title: 'Reports',
    appointmentReport: 'Appointment Report',
    providerReport: 'Provider Report',
    procedureReport: 'Procedure Report',
    revenueReport: 'Revenue Report',
    cancellationReport: 'Cancellation Report',
    noShowReport: 'No Show Report',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    generateReport: 'Generate Report',
    exportReport: 'Export Report',
    printReport: 'Print Report',
    reportGenerated: 'Report generated successfully',
    noDataForReport: 'No data available for the selected criteria',
    totalAppointments: 'Total Appointments',
    completedAppointments: 'Completed Appointments',
    cancelledAppointments: 'Cancelled Appointments',
    noShowAppointments: 'No Show Appointments',
    totalRevenue: 'Total Revenue',
    averageRevenue: 'Average Revenue',
    topProcedures: 'Top Procedures',
    topProviders: 'Top Providers',
    appointmentsByStatus: 'Appointments by Status',
    appointmentsByProvider: 'Appointments by Provider',
    appointmentsByProcedure: 'Appointments by Procedure',
    dailyAppointments: 'Daily Appointments',
    weeklyAppointments: 'Weekly Appointments',
    monthlyAppointments: 'Monthly Appointments'
  },

  // Settings
  settings: {
    title: 'Settings',
    general: 'General',
    notifications: 'Notifications',
    googleCalendar: 'Google Calendar',
    backup: 'Backup',
    users: 'Users',
    clinicName: 'Clinic Name',
    clinicAddress: 'Clinic Address',
    clinicPhone: 'Clinic Phone',
    clinicEmail: 'Clinic Email',
    timezone: 'Timezone',
    language: 'Language',
    dateFormat: 'Date Format',
    timeFormat: 'Time Format',
    currency: 'Currency',
    emailNotifications: 'Email Notifications',
    smsNotifications: 'SMS Notifications',
    reminderTime: 'Reminder Time',
    calendarId: 'Calendar ID',
    apiKey: 'API Key',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    testConnection: 'Test Connection',
    connectionSuccessful: 'Connection successful',
    connectionFailed: 'Connection failed',
    backupDatabase: 'Backup Database',
    restoreDatabase: 'Restore Database',
    backupCreated: 'Backup created successfully',
    backupRestored: 'Backup restored successfully',
    addUser: 'Add User',
    editUser: 'Edit User',
    role: 'Role',
    permissions: 'Permissions',
    admin: 'Admin',
    user: 'User',
    viewer: 'Viewer'
  },

  // Booking form
  booking: {
    title: 'Book Your Appointment',
    subtitle: 'Schedule your visit with our experienced dental team',
    form: {
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      service: 'Service',
      date: 'Preferred Date',
      time: 'Preferred Time',
      message: 'Additional Notes',
      language: 'Preferred Language',
      submit: 'Book Appointment',
      submitting: 'Submitting...',
      success: 'Your appointment request has been submitted successfully!',
      error: 'There was an error submitting your request. Please try again.',
      required: 'This field is required'
    },
    services: {
      consultation: 'Consultation',
      cleaning: 'Cleaning',
      filling: 'Filling',
      crown: 'Crown',
      implant: 'Implant',
      veneer: 'Veneer',
      extraction: 'Extraction',
      root_canal: 'Root Canal',
      orthodontics: 'Orthodontics',
      surgery: 'Surgery',
      other: 'Other'
    },
    languages: {
      english: 'English',
      german: 'German',
      spanish: 'Spanish',
      russian: 'Russian'
    },
    times: {
      morning: '9:00 AM',
      midMorning: '10:00 AM',
      lateMorning: '11:00 AM',
      noon: '12:00 PM',
      afternoon: '2:00 PM',
      midAfternoon: '3:00 PM',
      lateAfternoon: '4:00 PM',
      evening: '5:00 PM'
    }
  },

  // Emergency
  emergency: {
    title: 'Dental Emergency',
    subtitle: 'We are here to help you 24/7',
    intro: 'If you are experiencing a dental emergency, please contact us immediately. Our emergency team is available around the clock to provide you with the care you need.',
    call: 'Call Now',
    whatsapp: 'WhatsApp',
    cta: 'Call 603 31 96 48',
    details: [
      {
        title: 'Availability',
        description: 'Our emergency team is available 24 hours a day, 365 days a year, including weekends and holidays.'
      },
      {
        title: 'Contact',
        description: 'Call us at 603 31 96 48 for immediate assistance. We also accept WhatsApp messages.'
      },
      {
        title: 'Common Emergencies',
        description: 'We treat severe tooth pain, broken teeth, knocked-out teeth, and other dental traumas.'
      },
      {
        title: 'Service',
        description: 'We provide immediate pain relief and long-term solutions using the latest dental technology.'
      }
    ],
    common: {
      title: 'Common Dental Emergencies',
      toothache: 'Severe Toothache',
      broken: 'Broken or Chipped Tooth',
      knocked: 'Knocked Out Tooth',
      bleeding: 'Bleeding Gums',
      swelling: 'Facial Swelling',
      lost: 'Lost Filling or Crown',
      // === Emergency SEO offensive: shared spoke/hub strings (contract keys) ===
      breadcrumbHome: 'Emergency Dentist',
      callNow: 'Call now: 603 31 96 48',
      whatsappCta: 'WhatsApp: send us a photo',
      bookOnline: 'Book an appointment online',
      backToHub: 'All emergencies: our emergency dental service in Palma',
      locationLine: 'You will find us at Avenida de Jaime III, 3 · 07012 Palma de Mallorca — with the Vía Roma and El Corte Inglés car parks just a few minutes\' walk away.',
      calloutReviews: '5.0 ★ on Google — 470+ reviews',
      authorBox: {
        label: 'Medical review',
        name: 'Jan David Heiringhoff',
        credential: 'Col·legiat No. 07001232 — Col·legi Oficial de Dentistes de Balears',
        reviewedLabel: 'Medically reviewed by',
        reviewedDate: 'Last reviewed: July 2026'
      },
      midCta: {
        title: 'In pain right now? Then let\'s talk.',
        body: 'Our emergency phone is answered 24/7 — and if we are with a patient, we call you back within 30 minutes. Centrally located at Avenida de Jaime III, with parking at Vía Roma and El Corte Inglés.',
        button: 'Call 603 31 96 48'
      }
    },
    instructions: {
      title: 'What to Do',
      toothache: 'Rinse with warm salt water and take over-the-counter pain medication.',
      broken: 'Save any pieces and rinse your mouth with warm water.',
      knocked: 'Handle the tooth by the crown, not the root. Keep it moist.',
      bleeding: 'Apply gentle pressure with a clean cloth or gauze.',
      swelling: 'Apply cold compress to the outside of your cheek.',
      lost: 'Keep the area clean and avoid chewing on that side.'
    },
    // === Designer redesign v2 (redesign emergency/DESIGN.md) ===
    v2: {
      heroBadge: 'AVAILABLE NOW • 24/7',
      heroAccent: 'We are here for you.',
      heroIntro: 'If you are experiencing severe pain, dental trauma, or a broken tooth, our expert emergency team provides immediate, empathetic care 365 days a year.',
      callBtn: 'CALL 603 31 96 48',
      whatsappBtn: 'WHATSAPP US',
      stats: {
        availability: 'Availability',
        daysAYear: 'Days a Year',
        responseTime: 'Response Time',
        rating: 'Patient Rating',
      },
      common: {
        title: 'Common Dental Emergencies',
        intro: 'Immediate attention is vital for long-term dental health. We treat all forms of urgent dental trauma with clinical excellence.',
        eyebrow: 'Expert Care in Palma',
        cards: [
          {
            title: 'Severe Tooth Pain',
            description: 'Pulsing or sharp pain often indicates infection or nerve damage requiring immediate relief.',
            checks: ['Immediate diagnostics', 'Root canal therapy'],
          },
          {
            title: 'Dental Trauma',
            description: 'Broken, chipped, or knocked-out teeth from accidents require swift action to save the tooth.',
            checks: ['Emergency reconstruction', 'Reimplantation service'],
          },
          {
            title: 'Abscess & Infection',
            description: 'Swelling and fever are signs of severe dental infections that need antibiotic or surgical intervention.',
            checks: ['Infection drainage', 'Pain management'],
          },
        ],
      },
      process: {
        title: 'What to do in an emergency?',
        steps: [
          {
            title: 'Call us immediately',
            description: 'Contact 603 31 96 48 right away. Briefly explain your symptoms so we can prepare for your arrival.',
          },
          {
            title: 'First aid measures',
            description: 'For pain: cool the area from outside. For a broken tooth: keep the fragment in milk or saliva.',
          },
          {
            title: 'Visit our clinic',
            description: 'Head to Avenida de Jaime III № 3, Palma. We maintain a central location for rapid accessibility.',
          },
        ],
      },
      location: {
        eyebrow: 'Our Practice',
        title: 'SeaDent Mallorca',
        intro: 'Located in the heart of Palma, our clinic combines a Mediterranean atmosphere with state-of-the-art medical technology.',
        addressLine1: 'Avenida de Jaime III № 3',
        addressLine2: '07012 Palma de Mallorca',
        hoursLabel: 'Mon – Fri: 09:00 – 18:00',
        emergencyHours: 'Emergency phone: available 24/7',
        directions: 'Get directions',
      },
      finalCta: {
        title: 'We are here for you.',
        intro: 'Dental pain can be overwhelming. Our empathetic team is ready to provide the relief and expertise you deserve — your smile is in the best hands.',
        button: 'URGENT CALL: 603 31 96 48',
      },
    },
    // === Emergency SEO offensive: hub upgrade (contract keys) ===
    triage: {
      title: 'When should you call immediately?',
      intro: 'Not every dental problem needs treatment within the hour — but some genuinely do. If you are unsure, simply call us: we will tell you honestly how urgent it is.',
      levels: [
        {
          tone: 'now' as const,
          label: 'Call right now',
          items: [
            'A tooth has been knocked out completely — every minute counts',
            'Swelling with fever, difficulty swallowing or breathing — call 112 first (or 061 in the Balearics), then us',
            'Heavy bleeding that will not stop',
            'Severe, throbbing pain that painkillers no longer touch'
          ]
        },
        {
          tone: 'today' as const,
          label: 'Same-day appointment',
          items: [
            'A broken or chipped tooth',
            'Toothache that is getting worse',
            'A swollen cheek or gum without fever',
            'A lost filling or crown that hurts'
          ]
        },
        {
          tone: 'week' as const,
          label: 'Within the next few days',
          items: [
            'A small chip without pain',
            'Sensitivity to hot or cold',
            'A lost filling or crown without pain',
            'Gums that bleed when brushing'
          ]
        }
      ]
    },
    hubCards: {
      title: 'What has happened? Find the right help',
      cards: [
        {
          icon: 'sick',
          title: 'Acute toothache',
          teaser: 'Throbbing, pulling or stabbing pain is often a sign that the tooth nerve is inflamed. We take your pain seriously and see you the same day.',
          linkText: 'Acute toothache — what helps now?',
          routeKey: 'emergency-toothache'
        },
        {
          icon: 'dentistry',
          title: 'Broken or knocked-out tooth',
          teaser: 'A chipped corner or a whole tooth knocked out — in most cases we can rebuild the tooth the very same day. For a knocked-out tooth, every minute counts.',
          linkText: 'Broken tooth — what to do?',
          routeKey: 'emergency-broken-tooth'
        },
        {
          icon: 'coronavirus',
          title: 'Abscess or swollen cheek',
          teaser: 'A swelling never appears without a reason — and an abscess does not go away on its own. Acting today prevents serious complications.',
          linkText: 'Dental abscess — why you should act today',
          routeKey: 'emergency-abscess'
        },
        {
          icon: 'luggage',
          title: 'Dental emergency on holiday',
          teaser: 'A toothache should not decide how your holiday ends. Our guide for visitors covers insurance, costs and how to reach us from your resort.',
          linkText: 'Dental emergency on holiday — your step-by-step guide',
          routeKey: 'emergency-tourists'
        },
        {
          icon: 'child_care',
          title: 'Child had a dental accident',
          teaser: 'Stay calm: baby teeth and permanent teeth need different first aid — a baby tooth must never be put back in. We explain what matters and treat your child gently.',
          linkText: 'Tooth accident in a child — first aid for parents',
          routeKey: 'emergency-broken-tooth'
        }
      ]
    },
    weekend: {
      title: 'Also available at weekends, on public holidays and at night',
      paragraphs: [
        'A dental emergency does not check the opening hours first — so our emergency phone, 603 31 96 48, is answered around the clock, every day of the year. If we are with a patient, we call you back within 30 minutes.',
        'Our practice at Avenida de Jaime III in Palma is open Monday to Friday from 9:00 to 18:00. Outside these hours, emergency appointments are arranged individually by phone: call us first, and we will organise the earliest possible slot for you.',
        'Whatever the calendar says: never sit out severe pain, a growing swelling or a knocked-out tooth. One call is enough — we tell you immediately what to do and when we can see you.'
      ]
    },
    hubSolve: {
      title: 'How we solve it at SeaDent',
      items: [
        {
          problem: 'Broken or chipped tooth',
          solution: 'Direct composite build-up in a single visit: freehand layering, no drilling — and if anything ever chips again, we repair just that spot. You leave with a complete tooth the same day.',
          linkText: 'Composite build-up in one visit',
          routeKey: 'composite'
        },
        {
          problem: 'Severe toothache',
          solution: 'Emergency root canal treatment under the dental microscope, supported by our dental laser and digital 3D X-ray (DVT). We always try to save the tooth first.',
          linkText: 'Our technology: microscope, laser & 3D X-ray',
          routeKey: 'technologies'
        },
        {
          problem: 'Implant trouble — even implants placed elsewhere',
          solution: 'Digital diagnostics and computer-guided implant planning let us assess and treat implants regardless of where they were placed — including Turkey or Hungary.',
          linkText: 'Implant treatment in Palma',
          routeKey: 'implants'
        }
      ]
    },
    hubFaq: {
      title: 'Frequently asked questions about our emergency service',
      items: [
        {
          q: 'How much does an emergency appointment cost?',
          a: 'You receive a written cost estimate before any treatment begins — no surprises. You can pay by card, and you get an itemised invoice plus all documents your insurance needs.'
        },
        {
          q: 'Can I reach you on a Sunday or public holiday?',
          a: 'Yes — our emergency phone is available 24/7, every day of the year. The practice is open Monday to Friday 9:00–18:00; outside those hours we arrange emergency appointments by phone.'
        },
        {
          q: 'My crown has broken off — is that an emergency?',
          a: 'If you are in pain, or a sharp edge is cutting your tongue or cheek, treat it as one. Keep the crown and bring it with you: in many cases we can re-cement it, or repair the tooth directly with composite.'
        },
        {
          q: 'My implant hurts — it was placed abroad. Can you still help?',
          a: 'Yes. We treat implant problems regardless of where the implant was placed — including implants from Turkey or Hungary. With digital 3D imaging we find the cause, re-fix loose crowns and treat inflammation around the implant.'
        },
        {
          q: 'Do you carry out emergency root canal treatment?',
          a: 'Yes — under the dental microscope and supported by the dental laser, with one clear goal: to save your tooth rather than extract it. In most cases the acute pain stops the same day.'
        },
        {
          q: 'My gums are bleeding heavily — what should I do?',
          a: 'Apply gentle pressure with a clean gauze pad or cloth and call us. Bleeding that will not stop — especially after an accident or an extraction — should always be checked the same day.'
        },
        {
          q: 'Which languages do you speak?',
          a: 'We look after you in English, German and Spanish — from the first phone call to the written report you take home.'
        }
      ]
    },
    homeTeaser: {
      title: 'Dental emergency? We are here for you.',
      body: 'Acute pain, a broken tooth, a swollen cheek — call 603 31 96 48. Our emergency phone is answered 24/7, and we call you back within 30 minutes. You will find us in the heart of Palma, at Avenida de Jaime III.',
      linkText: 'To our emergency dental service in Palma'
    },
    footerTitle: 'Emergency',
    // === Emergency SEO offensive: spoke pages (contract SpokeContent) ===
    brokenTooth: {
      breadcrumb: 'Broken tooth',
      h1: 'Broken a Tooth in Mallorca? We Can Bond It — Immediate Help in Palma',
      heroIntro: 'That moment of shock: a crunch, a fall — and suddenly a piece of your tooth is missing. Take a deep breath: in most cases the tooth can be rebuilt the very same day. Call us now, and we will tell you exactly what to do next.',
      heroNote: 'Tip: send us a photo of the tooth via WhatsApp — we will tell you straight away how urgent it is and what we can do.',
      warnbox: {
        title: 'Tooth knocked out completely? You have about 60 minutes.',
        body: 'A replanted tooth has the best chance of survival within roughly 60 minutes. Do not wait at home: call us WHILE you make your way here — 603 31 96 48. We will prepare everything for your arrival.'
      },
      sections: [
        {
          icon: 'healing',
          title: 'First aid: 4 steps that can save your tooth',
          intro: 'What you do in the first few minutes has a real influence on whether the tooth or fragment can be saved. Four simple steps:',
          items: [
            {
              title: '1. Keep the tooth or fragment moist',
              body: 'Place it in cold milk or, if none is available, in saliva or a sterile saline solution. Never store it dry, and never in plain water — the sensitive cells on the root surface would be destroyed, and they are exactly what makes reattachment possible. Pharmacies also sell a tooth rescue box, a small container with a special cell-preserving liquid: if there is a farmacia on your way to us, it is the best transport medium of all.'
            },
            {
              title: '2. Touch the tooth only by the crown',
              body: 'Hold a knocked-out tooth by the white chewing part only — never by the root. The delicate fibres on the root surface must stay intact for the tooth to heal back in.'
            },
            {
              title: '3. Do not clean it',
              body: 'Even if it landed on the ground: do not scrub, rub or disinfect the tooth. What looks like dirt may contain the very cells the tooth needs. If it is heavily soiled, swirl it briefly in cold milk at most.'
            },
            {
              title: '4. Cool the area and head to us',
              body: 'A cold pack wrapped in a cloth against the cheek reduces swelling and eases the pain. Then call us on 603 31 96 48 and come in — ideally, call while you are already on your way.'
            }
          ]
        },
        {
          icon: 'table_chart',
          title: 'Chipped, knocked out or loosened? What your situation means',
          intro: 'Not every dental injury is equally urgent. This overview tells you what to expect — and when the clock is truly ticking:',
          table: {
            headers: ['Situation', 'How urgent?', 'What we typically do'],
            rows: [
              ['Corner or edge chipped off', 'Same-day appointment', 'Direct composite build-up in one visit — usually without any drilling'],
              ['Larger fracture, tooth sensitive or bleeding', 'Come in today — the nerve may be exposed', 'Protect the nerve, rebuild the tooth, save it wherever possible'],
              ['Tooth knocked out completely', 'Extreme emergency — about 60 minutes', 'Replantation and splinting, healing monitored under the dental microscope'],
              ['Tooth loosened or pushed out of position', 'Call immediately, avoid chewing on it', 'Gently reposition and stabilise with a splint, then monitor the nerve']
            ]
          }
        },
        {
          icon: 'diamond',
          title: 'Crown or veneer broken off?',
          intro: 'The good news first: a broken crown or veneer is rarely a race against the clock — but it does deserve attention the same day, before the exposed tooth underneath is damaged.',
          items: [
            {
              body: 'If the crown has come off in one piece, keep it safe and bring it with you — in many cases we can clean and re-cement it within minutes.'
            },
            {
              body: 'If the crown or veneer itself has fractured, we can usually repair the visible area directly with composite, or take a digital impression with our intraoral scanner for a precise replacement — no goo-filled impression trays.'
            },
            {
              body: 'One thing you should never do: glue a crown back in yourself. Household adhesives are toxic to the tooth and can make a proper re-fit impossible.'
            }
          ]
        }
      ],
      solve: {
        title: 'How we solve it at SeaDent: bonded back in a single visit',
        intro: 'Our answer to a broken tooth is the direct composite build-up — and it is the reason we say: we can bond it. In one visit, we rebuild your tooth by hand, layer by layer, until nobody can tell anything ever happened.',
        points: [
          {
            title: 'One visit, same-day result',
            body: 'We rebuild the missing part directly on the tooth in freehand layering technique, using tooth-coloured composite. No laboratory, no temporary, no second appointment — you walk out with a complete tooth the same day.'
          },
          {
            title: 'No drilling, nothing sacrificed',
            body: 'The build-up is purely additive: your healthy tooth structure stays completely untouched, and in most cases the treatment does not even need an anaesthetic.'
          },
          {
            title: 'Repairable for life',
            body: 'And what if another piece chips off one day? We repair exactly that spot — you will not need a new crown. Composite can be polished, extended and mended locally at any time.'
          },
          {
            title: 'Knocked-out tooth: replantation and splinting',
            body: 'If the whole tooth is out and you reach us within the critical window, we replant it, stabilise it with a splint and monitor the healing closely — with the dental microscope on our side.'
          }
        ],
        links: [
          { text: 'Direct composite build-up — your tooth rebuilt in one visit', routeKey: 'composite' },
          { text: 'Our technology: dental microscope, laser & 3D X-ray', routeKey: 'technologies' }
        ]
      },
      faq: {
        title: 'Frequently asked questions',
        items: [
          {
            q: 'How long can a broken or knocked-out tooth be saved?',
            a: 'A knocked-out tooth has the best chance within about 60 minutes, kept moist in milk or saliva. A broken-off fragment is far less time-critical — but the exposed tooth surface is vulnerable, so come in the same day if you can.'
          },
          {
            q: 'What does the composite build-up cost?',
            a: 'That depends on the size of the defect. You receive a written cost estimate before we start — nothing happens without your agreement — and you can pay by card.'
          },
          {
            q: 'My child has broken or knocked out a tooth — what now?',
            a: 'For a permanent tooth, the same rules apply: keep it moist, touch only the crown and come in immediately. A baby tooth is different — never put a baby tooth back in, because replanting it can damage the adult tooth developing underneath. Keep your child calm, cool the cheek from outside and call us: we will gently check whether anything else is injured.'
          },
          {
            q: 'Will my travel insurance pay for this?',
            a: 'Most travel policies cover acute dental treatment abroad up to a policy limit. You receive an itemised invoice and every document you need to claim — our guide for dental emergencies on holiday explains the details.'
          },
          {
            q: 'Does a composite build-up really last?',
            a: 'With good care, direct composite restorations can last many years — often up to 20. And unlike a crown, composite can be repaired locally at any point instead of being replaced.'
          }
        ]
      },
      finalCta: {
        title: 'Call now — in most cases we can rebuild your tooth today',
        body: 'The sooner we see you, the more we can save. Call 603 31 96 48 or send us a photo via WhatsApp — our emergency phone is answered 24/7, and we call you back within 30 minutes.'
      }
    },
    toothache: {
      breadcrumb: 'Acute toothache',
      h1: 'Acute Toothache in Mallorca? We Take Your Pain Seriously — Same-Day Appointment in Palma',
      heroIntro: 'Toothache has a way of taking over everything — eating, sleeping, thinking. You do not have to tough it out: call us now on 603 31 96 48, and we will find you an appointment today. If we are treating a patient when you call, we phone you back within 30 minutes.',
      heroNote: 'Prefer to write? Send us a WhatsApp message describing your pain — we answer quickly and tell you what to do until your appointment.',
      sections: [
        {
          icon: 'emergency',
          title: 'When is toothache an emergency?',
          intro: 'Some toothache can wait a day or two. These warning signs cannot — call us straight away if any of them sound familiar:',
          items: [
            {
              body: 'Throbbing, pulsing pain that keeps you from sleeping — the classic sign of an inflamed tooth nerve (pulpitis)'
            },
            {
              body: 'Pain together with a swollen cheek, gum or face — this may be an abscess; it will not resolve on its own, and our dental abscess page explains why acting today matters'
            },
            {
              body: 'Fever, feeling generally unwell, or difficulty swallowing alongside the pain — with difficulty breathing or swallowing, call 112 (or 061 in the Balearics) first'
            },
            {
              body: 'Sharp pain when biting on one specific tooth, getting worse day by day'
            },
            {
              body: 'A tooth that suddenly stops hurting after days of severe pain — this is not good news: the nerve may have died while the infection continues silently'
            }
          ]
        },
        {
          icon: 'bedtime',
          title: 'Toothache at night: why it gets worse when you lie down',
          intro: 'Almost every patient tells us the same story: bearable during the day, unbearable at night. There are real reasons for this — lying flat increases the blood pressure in your head, so the inflamed nerve comes under more pressure, and without the day\'s distractions pain simply feels louder. What helps you through until your appointment:',
          items: [
            {
              title: 'Sleep with your head raised',
              body: 'An extra pillow reduces the pressure in the inflamed area and often makes the pain noticeably more bearable.'
            },
            {
              title: 'Cool from the outside',
              body: 'A cold pack wrapped in a cloth against the cheek — about ten minutes on, ten minutes off. Never apply heat: warmth feeds an inflammation.'
            },
            {
              title: 'A word about painkillers',
              body: 'Over-the-counter painkillers can bridge the gap for a short time — follow the package leaflet or ask at the pharmacy, and tell us before treatment what you have taken. Important: products containing acetylsalicylic acid can increase the tendency to bleed.'
            },
            {
              title: 'Home remedies — honestly',
              body: 'Clove oil or rinsing with lukewarm salt water may take the edge off for a moment, but they treat nothing. Use them as a bridge to your appointment, not as a plan.'
            }
          ]
        },
        {
          icon: 'search',
          title: 'Common causes of acute toothache',
          intro: 'Toothache is a symptom, not a diagnosis. These are the causes we see most often:',
          items: [
            {
              title: 'Inflamed tooth nerve (pulpitis)',
              body: 'Deep decay or an old, leaking filling lets bacteria reach the nerve. The result: throbbing pain, strong sensitivity to hot and cold — and, untreated, a dying nerve.'
            },
            {
              title: 'Deep tooth decay',
              body: 'Decay hurts late. By the time a tooth aches persistently, the cavity is usually already close to the nerve — which is exactly why waiting rarely pays off.'
            },
            {
              title: 'A cracked tooth',
              body: 'A hairline crack — often after biting on something hard — can cause sharp pain on chewing that is hard to pin down. Our dental microscope makes precisely these cracks visible.'
            },
            {
              title: 'An abscess in the making',
              body: 'If bacteria spread past the root tip, pus builds up in the jaw. If your pain comes with swelling or fever, read our page on dental abscess — and act today.'
            }
          ]
        }
      ],
      solve: {
        title: 'How we solve it at SeaDent: stop the pain, save the tooth',
        intro: 'Our first job is to stop your pain — today. Our second is to keep your tooth. Your tooth is not a case for the forceps here — we always try to save it first.',
        points: [
          {
            title: 'A precise diagnosis in minutes',
            body: 'Our digital 3D X-ray (DVT) shows tooth, root and bone in three dimensions — we see exactly where the problem sits instead of guessing.'
          },
          {
            title: 'Emergency root canal under the dental microscope',
            body: 'Working under the microscope, we can see and clean even the finest root canals — the reason microscope-assisted root canal treatment has significantly higher success rates. The inflamed nerve tissue is removed, and with it the pain.'
          },
          {
            title: 'The dental laser against the bacteria',
            body: 'Our dental laser disinfects the root canals far more thoroughly than rinsing alone — for a result that lasts, not a pause between two emergencies.'
          },
          {
            title: 'Relief the same day',
            body: 'In the vast majority of cases you leave your first emergency appointment with the acute pain stopped and a clear, honest plan for your tooth. If a second visit is needed to finish the treatment, we tell you exactly why, what it involves and what it will cost — before anything happens.'
          }
        ],
        links: [
          { text: 'Our technology: dental microscope, laser & 3D X-ray', routeKey: 'technologies' }
        ]
      },
      faq: {
        title: 'Frequently asked questions',
        items: [
          {
            q: 'Will I really get an appointment today?',
            a: 'We keep room in our schedule for emergencies every day. Call 603 31 96 48 — if we cannot pick up immediately, we call you back within 30 minutes and tell you exactly when to come in.'
          },
          {
            q: 'What does an emergency appointment cost?',
            a: 'You receive a written cost estimate before any treatment starts, and we explain what is necessary now and what can wait. You can pay by card and receive an itemised invoice for your insurance.'
          },
          {
            q: 'Do home remedies actually help?',
            a: 'Briefly, at best. Salt water rinses or clove oil may dull the pain for a short while, but they cannot reach the cause — an inflamed nerve does not heal on its own. Use them to bridge the hours until your appointment, then let us treat the cause.'
          },
          {
            q: 'What if it happens at the weekend?',
            a: 'Our emergency phone is answered 24/7, every day of the year — see the availability section on our emergency service page. Appointments outside regular hours are arranged by phone.'
          },
          {
            q: 'Does a root canal treatment hurt?',
            a: 'The treatment itself is carried out under effective local anaesthetic. Most patients feel relief rather than pain — because the pressure on the inflamed nerve is finally gone.'
          }
        ]
      },
      finalCta: {
        title: 'Stop enduring it — call us now',
        body: 'Pain is your body asking for help — let us answer it. Call 603 31 96 48 or message us on WhatsApp: we take it from there, usually the very same day.'
      }
    },
    tourists: {
      breadcrumb: 'Dental emergency on holiday',
      h1: 'Dental Emergency on Holiday in Mallorca — Your Step-by-Step Guide',
      heroIntro: 'A dental emergency is stressful enough at home — abroad, possibly in a language you do not speak, it can feel overwhelming. Breathe out: you have found an English-speaking dental team in the centre of Palma that treats holiday emergencies every week. We speak English, German and Spanish — and we will get you back to your holiday.',
      heroNote: 'The fastest way to reach us from your sun lounger: WhatsApp. Send a photo and a short description of what happened — we reply quickly with clear next steps, in your language.',
      sections: [
        {
          icon: 'beach_access',
          title: 'The 4 most common holiday emergencies',
          intro: 'These four bring most holidaymakers to our practice. Here is the short version — each has its own detailed help page:',
          items: [
            {
              title: 'Acute toothache',
              body: 'Throbbing pain that ruins every beach day — usually an inflamed tooth nerve. We stop the pain the same day and always try to save the tooth first. Details: acute toothache — what helps now.'
            },
            {
              title: 'Broken or knocked-out tooth',
              body: 'Beach volleyball, a slip by the pool, an olive stone: teeth break quickly on holiday. In most cases we rebuild the tooth in a single visit — and a completely knocked-out tooth is a race against the clock, so call immediately. Details: broken tooth — what to do.'
            },
            {
              title: 'Lost filling or crown',
              body: 'Suddenly there is a hole — or the crown is sitting in your hand. Keep the crown safe, avoid chewing on that side and come in: re-cementing or a direct composite repair is usually done quickly.'
            },
            {
              title: 'Abscess or swollen cheek',
              body: 'Swelling, pressure, perhaps fever: an abscess does not go away on its own, and on holiday you should not gamble with it. We relieve the pressure and treat the cause. Details: dental abscess — act today.'
            }
          ]
        },
        {
          icon: 'payments',
          title: 'Costs and insurance: what you should know as a visitor',
          intro: 'The honest answer to "what will it cost?" is: it depends on the treatment — and we will tell you before we start, never after. Here is how it works for visitors to Mallorca:',
          items: [
            {
              title: 'Written estimate before treatment',
              body: 'After the examination you receive a written cost estimate. Nothing happens without your agreement, and you can pay comfortably by card.'
            },
            {
              title: 'EHIC / GHIC: useful, but with clear limits',
              body: 'The European Health Insurance Card (EHIC) — or the UK Global Health Insurance Card (GHIC) — covers medically necessary care within Spain\'s public health system. Private clinics like ours are generally not covered by EHIC/GHIC, and public emergency dental care in Spain is typically limited to very basic measures. For everything beyond that, you pay privately first and claim afterwards.'
            },
            {
              title: 'Travel insurance usually reimburses',
              body: 'Most travel insurance policies cover acute, pain-relieving dental treatment abroad, usually up to a policy limit. Check your policy or call your insurer\'s emergency assistance line — emergency dental treatment is one of the most commonly included benefits.'
            },
            {
              title: 'Every document you need to claim',
              body: 'You leave with an itemised invoice, your examination findings and, on request, a written treatment report — everything your insurer needs for reimbursement, and everything your dentist at home needs to continue your care.'
            }
          ]
        },
        {
          icon: 'directions_car',
          title: 'Getting here from your hotel',
          intro: 'We are at Avenida de Jaime III, 3 in the centre of Palma — one of the city\'s best-known streets, and every taxi driver on the island knows it.',
          items: [
            {
              title: 'From Playa de Palma / S\'Arenal',
              body: 'About 20–30 minutes by taxi. By bus, take a line towards Palma city centre and get off near Jaime III or Plaça del Rei Joan Carles I — your hotel reception can point you to the quickest connection.'
            },
            {
              title: 'From Alcúdia / Port d\'Alcúdia',
              body: 'Roughly 50–60 minutes by car or taxi via the Ma-13. Regular buses run from Alcúdia to Palma\'s central station (Estació Intermodal), a 10–15 minute walk from our practice.'
            },
            {
              title: 'From Port d\'Andratx / Santa Ponsa',
              body: 'Around 30–40 minutes by car or taxi along the Ma-1. Buses from the southwest also arrive at Palma\'s central station.'
            },
            {
              title: 'Coming by rental car?',
              body: 'Use the public car parks Vía Roma or El Corte Inglés — both are just a few minutes\' walk from our door.'
            }
          ]
        },
        {
          icon: 'medical_information',
          title: 'Implant problems on holiday — including implants placed elsewhere',
          intro: 'A loose implant crown, pressure, bleeding or swelling around an implant — these things do not wait until you are home. And it genuinely does not matter to us where your implant was placed: even if it was done in Turkey, Hungary or anywhere else, we will treat you.',
          items: [
            {
              body: 'With digital 3D X-ray (DVT) and our experience in computer-guided implant planning, we can assess virtually any implant system, re-fix a loose crown and treat inflammation around the implant (peri-implantitis).'
            },
            {
              body: 'You receive a complete report and your X-ray images for the dentist or clinic that placed the implant — so your warranty and follow-up care at home remain intact.'
            }
          ]
        }
      ],
      solve: {
        title: 'How we solve it at SeaDent: treatment that saves your holiday',
        intro: 'Our goal for every holiday patient is simple: treat the problem properly, today — so you spend the rest of your week on the beach, not in waiting rooms. This is what that looks like in practice:',
        points: [
          {
            title: 'Definitive treatment, not a quick patch',
            body: 'Wherever possible we treat definitively in a single visit — a broken tooth, for example, is rebuilt directly with composite instead of being patched with a temporary that gives up at the airport.'
          },
          {
            title: 'Honest advice around your travel plans',
            body: 'We tell you openly what needs to happen now, what can safely wait until you are home, and how the treatment fits around your departure date.'
          },
          {
            title: 'Everything your dentist at home needs',
            body: 'You take home a multilingual treatment report plus your X-ray images, so your own dentist can seamlessly continue any follow-up care.'
          },
          {
            title: 'No language barriers',
            body: 'English, German and Spanish — from the first phone call to the invoice and report.'
          }
        ],
        links: [
          { text: 'Broken tooth? Composite build-up in one visit', routeKey: 'composite' },
          { text: 'Implant problems: implant treatment in Palma', routeKey: 'implants' }
        ]
      },
      faq: {
        title: 'Frequently asked questions from holiday patients',
        items: [
          {
            q: 'Do you accept the EHIC / GHIC card?',
            a: 'As a private clinic we cannot bill the Spanish public health system directly, so the EHIC/GHIC does not apply with us. You receive an itemised invoice that most travel insurers reimburse for acute treatment — check the emergency dental cover in your policy.'
          },
          {
            q: 'Can I pay by card?',
            a: 'Yes, all major cards are welcome. You also receive a written cost estimate before treatment and a complete invoice afterwards.'
          },
          {
            q: 'Am I fit to fly after treatment?',
            a: 'After most emergency treatments — fillings, composite build-ups, a started root canal — flying is no problem. After surgical procedures, or with an acute abscess, we advise you individually and honestly, because cabin pressure can play a role. Tell us your departure date and we plan the treatment around it.'
          },
          {
            q: 'Can you give me a certificate for my insurance or airline?',
            a: 'Yes. You receive an itemised invoice, your findings and, on request, a written medical report in English or German — everything insurers and airlines usually ask for.'
          },
          {
            q: 'Can I still get an appointment on my departure day?',
            a: 'Call us as early in the day as you can — 603 31 96 48. We keep room for emergencies every day and will tell you honestly whether treatment makes sense before your flight or is better completed at home.'
          }
        ]
      },
      finalCta: {
        title: 'One call — and your holiday is back on track',
        body: 'Call 603 31 96 48 or send us a WhatsApp photo. Emergency phone 24/7, call-back within 30 minutes, English spoken — in the heart of Palma.'
      }
    },
    abscess: {
      breadcrumb: 'Dental abscess',
      h1: 'Dental Abscess or Swollen Cheek? Act Today — We Are Available',
      heroIntro: 'A swollen cheek, throbbing pressure, a bad taste in your mouth — that is frightening, and your instinct not to ignore it is exactly right. The good news: treated today, a dental abscess is very manageable. Call us on 603 31 96 48 — we take every swelling seriously and will see you quickly.',
      warnbox: {
        title: 'When to call the emergency services first',
        body: 'If you have fever, difficulty swallowing, difficulty breathing, or the swelling is spreading towards your eye or throat: call the emergency number 112 (or 061 in the Balearic Islands) immediately — then call us.'
      },
      sections: [
        {
          icon: 'visibility',
          title: 'Recognising the symptoms',
          intro: 'An abscess is a build-up of pus caused by a bacterial infection. This is what it typically looks like:',
          items: [
            {
              title: 'Tooth abscess',
              body: 'Throbbing pain around one tooth, pain on biting, a tooth that suddenly feels "too tall", swelling of the gum or cheek — sometimes with fever and swollen lymph nodes. Often there were days or weeks of toothache beforehand.'
            },
            {
              title: 'Gum abscess',
              body: 'A localised, shiny, dome-shaped swelling on the gum, often with a visible pus point, tender to the touch. It can also be triggered by something lodged under the gumline, such as a food particle.'
            },
            {
              title: 'And harmless irritation?',
              body: 'Gums that bleed a little when brushing, or a mild soreness after biting something sharp, are usually not an abscess. But persistent bleeding, recurring swelling or a bump that keeps refilling belongs in our chair — not on a wait-and-see list.'
            }
          ]
        },
        {
          icon: 'warning',
          title: 'Why waiting is dangerous',
          intro: 'We say this calmly, not to frighten you — but you should know it: an abscess does not go away on its own.',
          items: [
            {
              body: 'The pus sits in enclosed tissue. Even if the swelling softens or bursts and briefly feels better, the infection underneath carries on — because the cause is still there.'
            },
            {
              body: 'From the jaw, the infection can spread into the deep tissue spaces of the face and neck. That is why fever, difficulty swallowing or a swelling moving towards the eye or throat are red-alert signs — see the warning box above.'
            },
            {
              body: 'Every day of waiting tends to make the treatment bigger, not smaller. Caught early, an abscess is often resolved with a small drainage and treatment of the tooth. Caught late, it can mean surgery and a hospital stay.'
            }
          ]
        },
        {
          icon: 'home_health',
          title: 'What you can do until your appointment',
          intro: 'Until we see you — ideally today — this genuinely helps:',
          items: [
            {
              title: 'Cool — never warm',
              body: 'A cold pack wrapped in a cloth against the cheek, in intervals of about ten minutes. Do not apply heat and avoid warm compresses: warmth accelerates the spread of the infection.'
            },
            {
              title: 'Never lance or squeeze it yourself',
              body: 'Opening an abscess is a sterile medical procedure. Doing it yourself pushes bacteria deeper into the tissue and can turn a local problem into a serious one.'
            },
            {
              title: 'Take it easy',
              body: 'Keep your head elevated, avoid exertion, alcohol and smoking. Over-the-counter painkillers can bridge the time until your appointment — follow the package leaflet or ask at the pharmacy, and tell us before treatment what you have taken. Products containing acetylsalicylic acid can increase the tendency to bleed.'
            }
          ]
        }
      ],
      solve: {
        title: 'How we solve it at SeaDent: relief today, cause treated',
        intro: 'Two things have to happen with an abscess: the pressure must be relieved, and the cause must be treated. We do both — and we do not simply send you away with a prescription.',
        points: [
          {
            title: 'Drainage: the pressure goes, the pain follows',
            body: 'Under local anaesthetic we open and drain the abscess in a controlled, sterile way. Most patients feel dramatic relief within hours.'
          },
          {
            title: 'The dental laser',
            body: 'We use our dental laser for bleeding control and to reduce bacteria in the infected area — gentle, precise and kind to the surrounding tissue.'
          },
          {
            title: 'Treating the cause: root canal under the microscope',
            body: 'An abscess almost always has a cause — usually an infected tooth nerve. Wherever possible, we save the tooth with a root canal treatment under the dental microscope instead of extracting it.'
          },
          {
            title: 'Antibiotics: when they are right, not by default',
            body: 'Whether you need an antibiotic is a medical decision your dentist takes after examining you. An antibiotic alone does not solve an abscess — it can support the treatment, but it never replaces it.'
          }
        ],
        links: [
          { text: 'Our technology: dental laser, microscope & 3D X-ray', routeKey: 'technologies' }
        ]
      },
      faq: {
        title: 'Frequently asked questions',
        items: [
          {
            q: 'Does an abscess go away on its own?',
            a: 'No. The swelling may fluctuate or even burst, which briefly relieves the pressure — but the infection and its cause remain. Without treatment it comes back, and usually worse.'
          },
          {
            q: 'Can I just get antibiotics without an appointment?',
            a: 'No — and that is for your protection. Antibiotics alone remove neither the pus nor the cause, and taking them without an examination can mask the symptoms while the infection quietly continues. After examining you, your dentist decides whether an antibiotic supports your treatment.'
          },
          {
            q: 'What does the treatment cost?',
            a: 'You receive a written cost estimate before treatment begins and can pay by card. You also get an itemised invoice and all documents for your insurance.'
          },
          {
            q: 'Can I fly with an abscess?',
            a: 'We advise against flying with an untreated abscess: cabin pressure can intensify the pain, and a spreading infection over the open sea is a risk not worth taking. Come and see us first — after drainage and treatment we will tell you honestly when flying is safe again.'
          }
        ]
      },
      finalCta: {
        title: 'Act today — call 603 31 96 48',
        body: 'An abscess is the one dental emergency where waiting truly costs you. Call now or send a WhatsApp message — our emergency phone is answered 24/7, and we call you back within 30 minutes.'
      }
    },
  },

  // Hero Section
  // Holiday / practice closure — site-wide banner plus the notice inside the
  // booking flow. {date} is spelled out at runtime in the active language.
  closure: {
    bannerTitle: 'Limited availability',
    bannerShort: 'Online booking closed until {date} inclusive. Phone and WhatsApp as usual.',
    bannerText: 'Online appointment booking is closed until {date} inclusive. You can still reach us by phone and WhatsApp as usual.',
    bookingTitle: 'Online booking paused',
    bookingText: 'No appointments can be booked here until {date} inclusive. Just call us or send a WhatsApp message — we will find a slot for you.',
    submitBlocked: 'Online booking is closed for this period. Please contact us by phone or WhatsApp.',
    upcomingTitle: 'Scheduled closure',
    upcomingText: 'From {from} to {until} inclusive no online booking is possible — those days are not selectable in the calendar. You can still reach us by phone and WhatsApp.',
    call: 'Call us',
    whatsapp: 'WhatsApp',
  },

  hero: {
    title: 'SeaDent Mallorca: Your Smile Matters.',
    subtitle: 'Modern dentistry with empathy.',
    description: 'Experience world-class dental care in the heart of Mallorca. Our modern clinic combines German precision with Mediterranean warmth.',
    cta: 'Book Appointment Online',
    emergency: 'Emergency Call',
    makeover: {
      title: 'Smile Makeover with Composite',
      subtitle: 'Direct freehand layering technique – minimally invasive and naturally beautiful.',
      cta: 'Learn more'
    },
    rotation: {
      on: 'Rotation: on',
      off: 'Rotation: off'
    },
    scrollMore: 'Learn more',
    ctaClosed: 'Request callback',
    banner: {
      title: "Experience personalized comfort",
      subtitle: "(and learn why our patients love to come back)",
      buttons: {
        cosmetic: "Cosmetic Dentistry",
        pediatric: "Pediatric Dentistry",
        general: "General Dentistry",
        whitening: "Teeth Whitening"
      }
    }
  },

  // Booking Wizard
  bookingWizard: {
    steps: {
      treatment: "What type of appointment?",
      insurance: "How would you like to pay?",
      dateTime: "Choose preferred date & time"
    },
    treatments: {
      cleaning: "Professional Dental Cleaning + Exam (Doctor)",
      returningCleaning: "Returning Patient Cleaning (RDH) + Exam (Doctor)",
      consultation: "General Dental Consultation (Doctor)",
      cosmetic: "Cosmetic Dental Consultation (Doctor)",
      secondOpinion: "Second Opinion Dental Consultation (Doctor)",
      emergency: "Emergency Dental Appointment (X-Rays + Doctor Exam)",
      whitening: "Professional Teeth Whitening Treatment",
      botox: "Botox Consultation (Doctor)",
      tmj: "TMJ (Jaw Pain) Consultation (Doctor)",
      pediatric: "Pediatric Dentistry (Children's Dental Care)"
    },
    insurance: {
      search: "Enter your insurance",
      privatePay: "Private pay",
      privatePayDesc: "Self-pay · no insurance required",
      withInsurance: "Via my insurance",
      withInsuranceDesc: "Enter insurance name"
    },
    navigation: {
      back: "Back",
      next: "Next",
      close: "Close"
    },
    notices: {
      leadTimeTitle: "Notice period for online appointments",
      leadTime: "Appointments can be booked online from the day after next onwards — at least one full working day stays free in between. Need something sooner? Just give us a call:",
      leadTimeOne: "At least one full working day stays free between booking and appointment — the earliest slot bookable online is {date}. Need something sooner? Just give us a call:",
      leadTimeMany: "At least {days} full working days stay free between booking and appointment — the earliest slot bookable online is {date}. Need something sooner? Just give us a call:",
      leadTimeNone: "The earliest slot bookable online is {date}. Need something sooner? Just give us a call:",
      latestEndTitle: "Latest finishing time",
      latestEnd: "This treatment finishes at {time} at the latest. The last bookable appointment therefore starts earlier."
    },
    getDirections: "Get directions",
    instantBookingBy: "Instant booking by"
  },

  // Services Section
  services: {
    title: 'Our Services',
    subtitle: 'Comprehensive Dental Care',
    implants: {
      title: 'Dental Implants',
      description: 'Permanent solution for missing teeth with titanium implants'
    },
    veneers: {
      title: 'Veneers',
      description: 'Transform your smile with custom porcelain veneers'
    },
    cleaning: {
      title: 'Professional Cleaning',
      description: 'Thorough cleaning and prevention for optimal oral health'
    },
    crown: {
      title: 'Crowns & Bridges',
      description: 'Restore damaged teeth with high-quality crowns and bridges'
    },
    orthodontics: {
      title: 'Orthodontics',
      description: 'Straighten your teeth with modern orthodontic treatments'
    },
    surgery: {
      title: 'Oral Surgery',
      description: 'Expert surgical procedures in our modern operating rooms'
    }
  },

  // Treatments Section
  treatments: {
    title: "Treatments: Your Smile in the Best Hands",
    intro: "Our treatments at SeaDent Mallorca cover the entire spectrum of modern dentistry – from prevention to aesthetic perfection. With advanced technology and empathetic care, we ensure your oral health and a radiant smile.",
    cta: "Book appointment now",
    categories: [
      {
        title: "Prevention and Prophylaxis",
        description: "Regular check-ups and preventive measures for long-term oral health. We focus on individual consultation and modern diagnostics.",
        treatments: [
          {
            title: "Check-up and Consultation",
            description: "Comprehensive examinations and personal recommendations for healthy teeth."
          },
          {
            title: "Professional Dental Cleaning",
            description: "Thorough removal of dental plaque for a clean and fresh feeling."
          },
          {
            title: "Fillings",
            description: "High-quality fillings that restore your teeth aesthetically and functionally."
          },
          {
            title: "Children's Prophylaxis",
            description: "Child-friendly prevention to protect your little ones' teeth in a playful way."
          }
        ]
      },
      {
        title: "Pain Therapy",
        description: "Pain-free treatments through gentle techniques and the latest technologies. Your well-being is the focus of every session.",
        treatments: [
          {
            title: "Pain Treatment",
            description: "Fast and effective relief from dental pain, individually tailored to you."
          },
          {
            title: "Tooth Extraction",
            description: "Gentle removal of teeth when no other solution is possible."
          },
          {
            title: "Root Canal Treatment",
            description: "Precise endodontics to save inflamed teeth and relieve pain."
          },
          {
            title: "TMJ Problems",
            description: "Targeted therapy for temporomandibular joint (TMJ) problems for better quality of life."
          }
        ]
      },
      {
        title: "Periodontitis",
        description: "Professional treatment of gum disease for stable oral health. Early measures prevent long-term damage.",
        treatments: [
          {
            title: "Treatment Measures",
            description: "Professional cleaning and therapies to effectively combat gum inflammation."
          }
        ]
      },
      {
        title: "For a Perfect Smile (Aesthetics)",
        description: "Aesthetic solutions for a confident smile, tailored to your wishes. Our methods are gentle and effective.",
        treatments: [
          {
            title: "Composite Build-up",
            description: "Direct aesthetic build-up in a single visit – no drilling, freehand layering technique."
          },
          {
            title: "Invisalign",
            description: "Transparent aligners for discreet and comfortable tooth correction."
          },
          {
            title: "Teeth Whitening",
            description: "Gentle whitening of your teeth for a radiant, white smile."
          },
          {
            title: "Grinding Guards",
            description: "Custom-made guards to prevent teeth grinding and protect your teeth."
          },
          {
            title: "Veneers",
            description: "Ultra-thin ceramic shells for a perfect and natural appearance of your teeth."
          },
          {
            title: "Crowns and Bridges",
            description: "High-quality dental prosthetics for function and aesthetics of damaged teeth."
          }
        ]
      },
      {
        title: "Implants",
        description: "State-of-the-art implant technology for natural and permanent tooth replacement. Our implants offer you comfort and security.",
        treatments: [
          {
            title: "Single Implants",
            description: "Replacement of individual teeth with high-quality implants for a natural feeling."
          },
          {
            title: "Multiple Implants",
            description: "Comprehensive implant solutions for larger tooth gaps or complete tooth rows."
          },
          {
            title: "Immediate Implants",
            description: "Implants with immediate loading for quick restoration of your chewing function."
          }
        ]
      }
    ]
  },

  // Benefits Section
  benefits: {
    title: 'Your benefits: Excellence, comfort and a smile that shines.',
    items: [
      {
        title: 'Experience and Expertise',
        description: 'Qualified dentists with continuous education and training.'
      },
      {
        title: 'Cutting-edge Technology',
        description: 'Precise treatments with digital X-rays and innovative equipment.'
      },
      {
        title: 'Patient-centered Care',
        description: 'Empathetic treatment as you would expect from a friend.'
      },
      {
        title: 'Mediterranean Atmosphere',
        description: 'A relaxed environment inspired by the beauty of Mallorca.'
      },
      {
        title: 'Multilingual Service',
        description: 'Treatment in German, English and Spanish.'
      },
      {
        title: 'Central Location',
        description: 'Easily accessible in the heart of Palma de Mallorca.'
      }
    ]
  },

  // Approach Section
  approach: {
    title: 'Dentistry reimagined: Your comfort, our commitment.',
    text: 'At SeaDent, we want your visit to the dentist to be something special. Our mission is to offer you not only medically excellent treatments, but also an atmosphere where you feel relaxed and understood. This means for us:',
    points: [
      'We listen to you: Your wishes and needs are at the center of our care. We take time for personalized consultation.',
      'Relaxation and pain-free treatments: Using state-of-the-art techniques and focusing on your well-being, we make treatments as comfortable as possible.',
      'Transparency creates trust: We explain every step of your treatment clearly and understandably, so you feel confident.'
    ]
  },

  // Team Section
  team: {
    title: 'Our Team',
    subtitle: 'Experts for Your Smile',
    description: 'Our experienced team of dentists and dental hygienists is dedicated to providing you with the best possible care.',
    cta: 'Meet Our Team'
  },

  // Experience Section
  experience: {
    title: 'Your moments of well-being at SeaDent Mallorca.',
    text: 'At SeaDent, it\'s about more than just dentistry – we want your visit to become a moment of relaxation. Our practice combines cutting-edge treatments with an atmosphere inspired by the tranquility and beauty of Mallorca.',
    points: [
      'Welcoming atmosphere with Mediterranean colors and natural light.',
      'Friendly and empathetic team that warmly welcomes you.',
      'Short waiting times thanks to efficient practice management.',
      'Comfortable waiting areas with WiFi, drinks and plants.',
      'Relaxing details like soothing music during treatment.'
    ]
  },

  // Social Proof Section
  socialProof: {
    title: "What our patients say",
    reviews: [
      {
        text: "Professionally top-notch, humanly great, you really feel well taken care of here ❤️. A huge thank you to the dentist and the whole team. This is exactly how I imagine a modern, warm practice to be 🦷🤗.",
        author: "Marcel"
      },
      {
        text: "I have never experienced such a dedicated, warm, and honest dentist. He always takes a lot of time – even outside of normal practice hours – and is always there for his patients. The treatments are professional and carried out with a lot of empathy. Even after the appointment, he takes care of the follow-up and wants to know how you are doing – that is anything but a matter of course. An absolutely great dentist whom you can trust completely. Absolute recommendation!",
        author: "Stefanie"
      },
      {
        text: "Top dentist!!! Of course, I got extreme toothache right during my holiday after a filling that was a few weeks ago. Waiting until I could go to my dentist back home in Germany was not possible. I got an appointment with Jan D. Heiringhoff immediately. He is super likeable, listens, asks questions, and did the necessary root canal treatment perfectly. My dentist in Germany later said that he did a great job with the root canal treatment. I had no problems or even pain during or after the treatment. I can highly recommend him!",
        author: "Hendrik"
      },
      {
        text: "I was really very happy to receive a quick and uncomplicated answer after a sleepless night due to acute toothache. The treatment was also prompt and professional. It's nice that there are still doctors who also work on Saturdays and are still very friendly and competent. Thank you very much.",
        author: "T."
      },
      {
        text: "Immediate (!) and professional emergency treatment. Transparent and at eye level. Many thanks to the team, I felt very well taken care of. SUPPLEMENT (a few months later): Back in the practice and this time took advantage of bleaching. Everything professional and friendly. Simply a recommendable practice! 👍",
        author: "Hubert"
      },
      {
        text: "I was received and treated in a super friendly manner. Dr. Heiringhoff took a lot of time and explained everything in detail. At my request, he took 2 X-rays of my new crown. I was afraid I had a root infection. That wasn't the case and I was able to leave with peace of mind. I can absolutely recommend Dr. Heiringhoff. Thank you for the quick help on a Sunday ☺️.",
        author: "Elke"
      },
      {
        text: "To be honest, my teeth looked really 'crack' before – so much so that I preferred to look serious in photos rather than smile. But then came Jan! The guy turned my teeth into a smile that's something to behold. Super relaxed, zero dentist fear, and real attention to detail. Now I'm grinning again as if I'd just stepped out of a toothpaste advert. Thanks, Jan – you're my tooth hero!",
        author: "Patrick"
      },
      {
        text: "Many thanks for the quick help. Had a dental emergency during my holiday. Got an appointment immediately, where I was super advised and treated. Recommendation from the heart.",
        author: "Simone"
      }
    ]
  },

  // Technologies Section
  technologies: {
    title: 'Modern Technology',
    subtitle: 'State-of-the-Art Equipment',
    intro: 'At SeaDent, we prioritize individual, pleasant, and painless dentistry through the use of cutting-edge technology.',
    sections: [
      {
        title: 'Digital Dentistry',
        description: 'Digital impressions and 3D imaging for precise diagnostics and treatment planning.',
        benefits: [
          'Fast and convenient digital tooth capture.',
          'Significantly higher comfort than with impressions.',
          'Possibility to visualize your treatment results.',
          'Contributes to faster and more pleasant treatment.'
        ]
      },
      {
        title: 'Dental Laser: The Healing Light',
        description: 'A dental laser is a versatile instrument that replaces many conventional tools and supports healing. It operates precisely, efficiently, and safely. Benefits of the Dental Laser for you:',
        benefits: [
          'Supports the healing of gums, bone, and more.',
          'Enables minor surgical procedures.',
          'Helps in the sterilization of root canals.',
          'Used for hemostasis (stopping bleeding) during procedures.',
          'Effective treatment for canker sores and herpes.',
          'Supports periodontitis treatment.',
          'Helps in desensitizing sensitive tooth necks.'
        ]
      },
      {
        title: 'Implant Technology',
        description: 'Advanced implant systems for optimal integration and long-term success.',
        benefits: [
          'High-quality biocompatible materials',
          'Computer-guided planning for maximum safety',
          'Long-lasting and natural-looking results'
        ]
      },
      {
        title: 'Dental Microscope',
        description: 'Microscopic precision for endodontic treatments and fine surgical procedures.',
        benefits: [
          'Maximum accuracy in details',
          'Higher success rates for root canal treatments',
          'Preservation of as much natural tooth structure as possible'
        ]
      }
    ],
    conclusion: 'By combining these modern technologies with our focus on trust and transparency, you will experience dentistry at SeaDent that is professional, pleasant, and personal.'
  },

  cta: {
    title: 'Experience dentistry that puts you first.',
    text: 'Ready for a dental practice that combines professionalism with Mediterranean comfort? Book your appointment at SeaDent Mallorca and discover a new kind of dentistry – we look forward to welcoming you to Palma!',
    bookButton: 'Book Online Appointment',
    callButton: 'Call Us',
    visitInfo: 'Visit us: Avenida de Jaime III № 3, Palma, Mallorca.'
  },

  // Footer
  footer: {
    legal: {
      title: 'Legal Notice',
      privacy: 'Privacy Policy',
      cookieSettings: 'Cookie Settings'
    },
    links: {
      title: 'Navigation',
      home: 'Home',
      contact: 'Contact',
      book: 'Book Appointment'
    },
    contact: {
      title: 'Contact Information',
      practice: 'SeaDent Mallorca',
      address: 'Avenida de Jaime III, № 3',
      city: '07012 Palma de Mallorca',
      owner: 'Inhaber: Jan D. Heiringhoff',
      phone: '603 31 96 48',
      whatsapp: 'WhatsApp: 603 31 96 48',
      email: 'info@seadent.es',
      hours: 'Mon-Fri: 09:00 - 18:00'
    },
    copyright: '© {year} SeaDent Mallorca. All rights reserved.'
  },
  implants: {
    title: 'Implants – For a Better Quality of Life',
    intro: 'Dental implants are the most modern and natural way to replace missing teeth. They offer not only perfect aesthetics but also give you back the feeling and security of your own teeth. In our practice in Palma, we rely on the highest quality standards and state-of-the-art procedures.',
    benefitsTitle: "Benefits of Implants",
    benefit1: "Natural look and feel, comparable to your own teeth",
    benefit2: "Improved chewing function and speaking ability",
    benefit3: "Long-lasting solution with a high success rate",
    benefit4: "Preservation of jawbone structure",
    qualityTitle: "Highest Quality and Precision",
    quality: "We use only high-quality materials and state-of-the-art digital planning procedures. This guarantees you a precise and long-lasting result that fits you perfectly.",
    experienceTitle: "Pleasant Treatment Experience",
    experience: "Thanks to minimally invasive techniques and gentle anesthesia, treatment with us is particularly gentle. Our goal is for you to feel comfortable and safe throughout the process.",
    processTitle: "The Path to Your New Implants",
    step1Title: "Consultation",
    step1: "Detailed discussion and individual planning",
    step2Title: "Implantation",
    step2: "Gentle procedure under local anesthesia",
    step3Title: "Healing",
    step3: "Integration of the implant with the jawbone",
    step4Title: "Prosthesis",
    step4: "Creation and insertion of the individual tooth replacement",
    // === Emergency SEO offensive: cross-link section (contract key) ===
    foreignImplants: {
      title: 'Implant problems — we also treat implants placed elsewhere',
      intro: 'Pain, a loose crown or swelling around an implant? We help — regardless of where your implant was placed.',
      body: 'We regularly see patients whose implants were placed in another practice or another country — including Turkey or Hungary. With digital 3D X-ray (DVT) and computer-guided implant planning we identify the cause precisely, re-fix loose implant crowns and treat inflammation around the implant (peri-implantitis). You also receive a complete report and your images for the clinic that placed the implant, so your follow-up care at home stays intact. And if the problem strikes during your holiday, our emergency team is there for you.',
      linkText: 'Dental emergency on holiday in Mallorca — your step-by-step guide'
    }
  },
  veneers: {
    title: 'Veneers – For Your Radiant Smile',
    intro: 'Ultra-thin ceramic shells, known as veneers, offer an elegant solution to permanently correct minor aesthetic imperfections on the front teeth. Whether it is discoloration, small gaps, or slight misalignments – we help you achieve a harmonious and natural smile.',
    imageAlt: "Veneer treatment at SeaDent Mallorca",
    description: "Veneers are individually manufactured shells that are firmly bonded to the tooth surface. They are characterized by their high biocompatibility and aesthetics that are hard to distinguish from natural teeth. In just a few sessions, we transform your smile and give you new self-confidence."
  },
  composite: {
    title: 'Direct Composite Restoration – Your New Smile in a Single Visit',
    intro: 'Direct, additive build-up of your teeth with tooth-coloured composite in freehand layering technique – no drilling, no laboratory, with a visible result the same day.',
    heroAlt: 'Before/after comparison of composite restoration at SeaDent Mallorca',
    heroCaption: 'Before and after, side by side. Composite build-up on the upper anterior teeth (right side of the image) shown next to the untreated side on the left. Shape, length, shade and brightness are tailored individually to your wishes.',
    whatIsTitle: 'What is direct composite restoration?',
    whatIsBody: 'Direct composite restoration is a modern, minimally invasive aesthetic dental procedure. We reshape the form, length, colour and position of your teeth – without grinding, without lab impressions and without temporaries. A high-grade, tooth-coloured composite is applied directly onto the tooth in successive thin layers, sculpted by hand and cured with polymerisation light.',
    whatIsResult: 'You see the result the same day you leave the practice.',
    distinctionTitle: 'Important: this is not a veneer',
    distinctionBody: 'Conventional ceramic veneers require the dentist to grind down healthy tooth structure to make room for the shell. Our procedure is purely additive: we add material without reducing the natural tooth – and the result is fully reversible.',
    indicationsTitle: 'Who is it for?',
    indications: [
      { title: 'Anterior aesthetic corrections', body: 'Chipped edges, uneven lengths, asymmetries and shape anomalies on visible front teeth.' },
      { title: 'Diastema closure', body: 'Gaps of up to approximately 6–7 mm can be closed without orthodontics.' },
      { title: 'Reconstruction of worn teeth', body: 'Restoring original tooth shape and length in cases of bruxism, erosion or age-related abrasion.' },
      { title: 'Additive smile makeover', body: 'Harmonious redesign of multiple anterior teeth in a single appointment.' }
    ],
    whyTitle: 'What makes our method distinctive',
    whyBuildupAlt: 'Photoreal macro of composite layering technique with light curing',
    why: [
      { title: 'Result in a single visit', body: '30–60 minutes per tooth. A complete anterior makeover (6–8 teeth) is completed in one appointment. No lab, no second visit, no temporary restoration.' },
      { title: 'Freehand layering technique', body: 'Dentin and enamel masses are sculpted in multiple layers – just like a natural tooth. The result has genuine depth, opalescence and light refraction.' },
      { title: 'Tissue-preserving & reversible', body: 'Your natural tooth substance remains fully intact. All future treatment options remain open.' }
    ],
    processTitle: 'The procedure step by step',
    processIllustrationAlt: 'Illustration of composite layering with polymerisation light',
    process: [
      { title: 'Consultation & analysis', body: 'Clinical examination, occlusal assessment, discussion of your wishes.' },
      { title: 'Shade & shape selection', body: 'Choice of composite shades for dentin and enamel layers.' },
      { title: 'Preparation', body: 'Surface cleaning, rubber dam isolation, adhesive conditioning.' },
      { title: 'Layered build-up', body: 'Polychromatic layering with light curing of every layer.' },
      { title: 'Finishing & high-gloss polishing', body: 'Anatomical micro-texture and natural lustre.' },
      { title: 'Final check & result', body: 'Visual control, bite check, handover.' }
    ],
    aftercareTitle: 'After the treatment & care',
    aftercare: [
      'No downtime – you can eat and speak immediately',
      'First 24–48 hours: avoid strongly staining foods and drinks (coffee, red wine, tea, curry, berries)',
      'Care like your natural teeth – brush twice daily, interdental cleaning, regular professional hygiene',
      'Avoid chewing ice or opening packaging with your front teeth',
      'For bruxism patients: a custom night guard for protection'
    ],
    longevityTitle: 'Longevity',
    longevityBody: 'With good oral hygiene and regular professional care, direct composite restorations can last up to 20 years. Composite can be re-polished, extended and repaired locally – no full replacement required.',
    benefitsTitle: 'Benefits at a glance',
    benefits: [
      { label: 'Single visit', value: 'Visible result immediately' },
      { label: 'No drilling', value: '100 % of your natural tooth preserved' },
      { label: 'Layered build-up', value: 'Natural appearance, indistinguishable from real teeth' },
      { label: 'Reversible', value: 'All future treatment options remain open' },
      { label: 'Repairable', value: 'Small corrections without full replacement' },
      { label: 'Fair pricing', value: 'Significantly more affordable than lab-made restorations' }
    ],
    faqTitle: 'Frequently asked questions',
    faq: [
      { q: 'Is the treatment painful?', a: 'No. Because no drilling is involved, anaesthesia is usually unnecessary.' },
      { q: 'How long does an appointment take?', a: '30–60 minutes per tooth. A full smile makeover is scheduled in one day.' },
      { q: 'Can people tell it is not my own tooth?', a: 'With correctly executed layering using dentin and enamel masses, the composite is visually indistinguishable from natural enamel.' },
      { q: 'How do I care for the restored teeth?', a: 'Like your natural teeth. Professional cleanings every six months are important.' },
      { q: 'Will the material discolour?', a: 'Modern composite is highly colour-stable. Minor surface discolouration can usually be removed by polishing.' },
      { q: 'How long will the result last?', a: 'Up to 20 years with proper care. Repairs are always possible without replacing the whole restoration.' },
      { q: 'What if a piece chips off?', a: 'We repair the affected area locally, without replacing the entire restoration.' },
      { q: 'Am I a suitable candidate?', a: 'We will clarify this in a personal consultation. In cases of severe wear or bite problems we will openly discuss the most appropriate method.' },
      { q: 'What is the cost?', a: 'Depends on the number and complexity of teeth involved. You receive a written quote before treatment begins.' }
    ],
    ctaTitle: 'Ready for your new smile?',
    ctaBody: 'Schedule a personal consultation. We listen, examine carefully and tell you honestly what is achievable.',
    ctaButton: 'Book your consultation online',
    ctaCall: 'Or call us'
  },

  // Contact
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in Touch',
    contactInfo: 'Contact Information',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    emergencyTitle: 'Emergency Service',
    emergencyText: 'For dental emergencies, a 24/7 service is available',
    appointment: 'Appointment',
    findUsTitle: 'Where to find us',
    directionsButton: 'Get Directions',
    transportTitle: 'How to get here',
    publicTransport: 'Public Transport',
    publicTransportInfo: 'We are located in the heart of Palma, near major bus stops on Jaime III.',
    byCar: 'By Car',
    byCarInfo: 'Several public car parks are nearby, including Parking Vía Roma and El Corte Inglés.',
    form: {
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      success: 'Message sent successfully!',
      error: 'Error sending message. Please try again.'
    }
  },

  // SmartAI panel — digital reception on the public site
  smartai: {
    // --- Layout v2: booking and appointment management inside the panel -------
    v2: {
      greeting: 'Hello. How can we help?',
      greetingSub: 'Pick a topic — or simply write it below.',
      greetingSubNoChat: 'Pick a topic.',
      groupAppointment: 'Appointment',
      book: 'Book an appointment',
      bookHint: 'Pick from the free slots right here',
      reschedule: 'Reschedule',
      cancel: 'Cancel',
      groupHelp: 'Help & contact',
      help: 'Ask a question',
      callback: 'Call me back',
      emergency: 'Dental emergency — call now',
      emergencyHint: 'We call back in under 30 minutes',
      askPlaceholder: 'Write your question or request',
      backHome: 'Overview',
      manageIntro: 'To reschedule we need a short confirmation by email — appointments are personal health data.',
      cancelIntro: 'To cancel we need a short confirmation by email — appointments are personal health data.',
      pickTreatment: 'What is it about?',
      minutes: 'minutes',
      change: 'Change',
      loading: 'One moment…',
      free: 'free',
      moreDays: 'More',
      noDays: 'Nothing is available online right now. Give us a call — by phone we usually find something: +34 603 31 96 48',
      noSlots: 'Nothing left on this day.',
      toContact: 'Continue to your details',
      holdHint: 'This time is held for you for 10 minutes',
      holdFailed: 'We could not hold this time — please finish the booking quickly.',
      slotGone: 'This time has just been taken. Please pick another one.',
      errorGeneric: 'That did not work. Please try again or call us: +34 603 31 96 48',
      fieldName: 'Name',
      fieldEmail: 'Email',
      emailHint: 'This is where the confirmation goes, including the link to reschedule or cancel.',
      fieldPhone: 'Phone',
      fieldMessage: 'Note',
      optional: 'optional',
      submit: 'Request this appointment',
      submitting: 'Sending…',
      privacyHint: 'Your details go straight to the practice and are never passed to an AI.',
      doneTitle: 'Appointment requested',
      doneBody: 'You will receive a confirmation by email shortly. It contains the link you can use to reschedule or cancel at any time.',
      doneNoMail: 'We received your appointment. The confirmation email could not be delivered — please give us a quick call so we can check the address.',
      close: 'Done',
      openUntil: 'Open until',
      closedHoliday: 'Holiday closure · closed until',
      closedNow: 'Closed · open again at',
      oclock: '',
      labelPractice: 'Practice',
      hoursLine: 'Mon–Fri 09:00–18:00',
      labelEmergency: 'Emergency',
      emergencyLine: 'around the clock, weekends included',
      labelAddress: 'Address',
      call: 'Call',
      directions: 'Directions',
      faqTitle: 'Frequently asked',
      faqStarters: [
        'Where can I park nearby?',
        'Does my travel health insurance cover this?',
        'Can I still get an appointment today?',
      ],
      callbackTitle: 'Request a call back',
      callbackHint: 'We call you at the time that suits you',
      requestCode: 'Request a code',
      fastPathTitle: 'Fastest without a code',
      fastPathBody: 'Your confirmation and reminder emails contain the link „Manage appointment". One click and you are in.',
      enumerationHint: 'Without confirmation we show no appointment details — not even if the address is known to us.',
      codeSent: 'We sent a 6-digit code to {{email}}.',
      codeValidity: 'Valid for 10 minutes',
      codeResend: 'Send a new code',
      codeConfirm: 'Confirm code',
      checking: 'Checking…',
      changeEmail: 'Use a different email address',
      codeInvalid: 'That code is not correct.',
      codeExpired: 'The code has expired. Please request a new one.',
      codeLocked: 'Too many attempts. Please request a new code.',
      yourAppointments: 'Your appointments',
      noAppointments: 'There is no upcoming appointment for this address. If you are sure there is one, please call us: +34 603 31 96 48',
      currentAppointment: 'Your appointment so far',
      pickNewTime: 'Pick a new time',
      confirmReschedule: 'Reschedule appointment',
      backToList: 'Back to the overview',
      cancelConfirm: 'Really cancel this appointment?',
      cancelYes: 'Yes, cancel it',
      cancelNo: 'Keep it',
      cancelBlocked: 'This appointment can no longer be cancelled online. Please call us: +34 603 31 96 48',
      rescheduleBlocked: 'This appointment can no longer be rescheduled online. Please call us: +34 603 31 96 48',
      cancelDone: 'Appointment cancelled',
      cancelDoneBody: 'The appointment is cancelled and a confirmation is on its way by email. The slot now goes to someone else — thank you for letting us know in time.',
      rescheduleDone: 'Appointment rescheduled',
      rescheduleDoneBody: 'The new appointment is set. The confirmation with all the details is on its way to you.',
    },
    buttonLabel: 'Appointment, prescription or question?',
    title: 'Digital Reception',
    aiTransparency: 'Digital assistant — not a human. In an emergency, please call.',
    close: 'Close',
    back: 'Back',
    homeIntro: 'How can we help?',
    actions: {
      book: 'Book appointment',
      bookHint: 'Online, around the clock',
      manage: 'Change / cancel appointment',
      callback: 'Request a callback',
      callbackHint: 'We will get back to you',
      documents: 'Prescription & documents',
      documentsHint: 'Prescription request, invoice, report',
    },
    manage: {
      title: 'Change or cancel your appointment',
      emailInfo: 'Enter the email address you booked with. We will send you the "Manage appointment" link so you can reschedule or cancel yourself.',
      emailLabel: 'Email address',
      submit: 'Send me the link',
      sending: 'Sending…',
      sentTitle: 'Email on its way',
      sent: 'If there are upcoming appointments for this address, you will receive an email with the management link within a few minutes. Check your spam folder if needed.',
      error: 'That did not work. Please try again or call us: 603 31 96 48',
      phoneHint: 'No access to that inbox? Give us a call:',
    },
    form: {
      callbackTitle: 'Request a callback',
      documentsTitle: 'Request prescription & documents',
      docTypeLabel: 'Type of request',
      docPrescription: 'Prescription',
      docDocument: 'Document (e.g. invoice, report)',
      name: 'Name *',
      phone: 'Phone *',
      email: 'Email (optional)',
      preferredTime: 'Preferred callback time (optional)',
      message: 'Your request (optional)',
      sending: 'Sending…',
      submit: 'Send',
      successTitle: 'Request submitted',
      success: 'Thank you! The practice team will get back to you shortly.',
      backHome: 'Back to overview',
      error: 'That did not work. Please try again or call us: 603 31 96 48',
      privacy: 'Your details are used only to process your request. See our privacy policy for details.',
    },
    chat: {
      homeLabel: 'Or simply ask your question:',
      placeholder: 'Your question…',
      ask: 'Ask',
      send: 'Send',
      intro: 'Ask your question — e.g. about opening hours, treatments or directions. Please do not include personal data (name, phone number) in your question.',
      piiHint: 'Please do not include personal data (name, phone number) in your question.',
      error: 'That did not work. Please try again or use the buttons above.',
      forward: 'Forward question to the team',
      forwarded: 'Forwarded — the team will get back to you.',
      forwardError: 'Forwarding failed — feel free to call us: 603 31 96 48',
      actionGeneric: 'Continue',
      actions: {
        booking: 'Start booking',
        manage: 'Manage appointment',
        callback: 'Request a callback',
        documents: 'Request prescription & documents',
      },
    },
  }
};